import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { User } from 'src/app/common-methods/models/user';
import { CommonService } from 'src/app/common-methods/services/common.service';
@Component({
  selector: 'app-database-ques-ans',
  templateUrl: './database-ques-ans.component.html',
  styleUrls: ['./database-ques-ans.component.css']
})
export class DatabaseQuesAnsComponent implements OnInit {

   @Input() mainForm: FormGroup;
  @Input() formArrName: string;
  @Input() miscHint = { qHint: '', aHint: '' };
  @Input() miscType: string;
  @Input() disableAnswer = false;
  @Input() hiddenAddRemove = false;
  rowCount = 1;
  userData = new User();
  constructor(public common: CommonService) { }
  ngOnInit() {
      this.userData = JSON.parse(sessionStorage.getItem('user_data'));
    this.rowCount = (this.mainForm.get(this.formArrName) as FormArray).controls.length;

    if (this.rowCount > 1) {
      this.removeQues(this.mainForm.get(this.formArrName).value.findIndex(x => x.screeningRecordCheckId === 0
        && x.recordCheckCategoryQues === '' && x.remark === ''));
    }
    if (this.userData.applicationId === 3) {
      this.disableAnswer = false;
    }
  }
  addQues() {
    if (this.mainForm.get(this.formArrName).valid) {
      const addMisc = this.mainForm.get(this.formArrName) as FormArray;
      addMisc.push(this.miscItems());
      } else {
      this.mainForm.get(this.formArrName).markAllAsTouched();
    }

  }
  removeQues(index) {
    if (index > -1) {
      const removeMisc = this.mainForm.get(this.formArrName) as FormArray;
      removeMisc.removeAt(index);
         }
  }
  getMiscFormGroup() {
    this.rowCount = (this.mainForm.get(this.formArrName) as FormArray).controls.length;
    return (this.mainForm.get(this.formArrName) as FormArray).controls;
  }
  miscItems(): FormGroup {
    return new FormGroup({
      miscId: new FormControl(0),
      miscQuestion: new FormControl('', Validators.required),
      miscAnswer: new FormControl(''),
      defaultQuestionFlag: new FormControl(false)
    });
  }
}
